import LTR from "@brand-icons/ploom/credits-card-default/credits-card-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const CreditsCardDefaultIcon = iconFactory("CreditsCardDefaultIcon", LTR);
